<template>
  <v-container fluid style="width: 100%; padding: 0" class="fontscolor">
    <Header />

    <article class="splash">
      <section class="fw-section">
        <div class="container fullwidthsec">
          <div class="row" style="padding-top: 50px">
            <div class="page-title title-size-normal text-dark">
              <div class="container white1">
                <div class="inner white1">
                  <div class="column white1">
                    <center>
                      <div class="titlelogin">
                        Log in to your Maposcope account
                      </div>
                    </center>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
              <div class="form-group padding-bottom-2x">
                <div class="row padding-bottom-1x">
                  <div class="col-xs-0 text-left"></div>
                  <div class="col-xs-12 text-right linklight">
                    <router-link to="signup">
                      New here? Sign up for free.
                    </router-link>
                  </div>
                </div>
                <label for="email" class="control-label white1">Email</label>
                <input
                  type="text"
                  v-model="email"
                  name="email"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !email }"
                  tabindex="110"
                />
                <div v-show="submitted && !email" class="invalid-feedback">
                  Email is required
                </div>
              </div>

              <div class="form-group">
                <div class="row padding-bottom-1x">
                  <div class="col-xs-0 text-left"></div>
                  <div class="col-xs-12 text-right linklight">
                    <router-link to="forgot-password">
                      Forgot password?</router-link
                    >
                  </div>
                </div>
                <label for="password" class="control-label white1"
                  >Password</label
                >
                <input
                  type="password"
                  v-model="password"
                  name="password"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !password }"
                />
                <div v-show="submitted && !password" class="invalid-feedback">
                  Password is required
                </div>
              </div>

              <div class="form-group">
                <p class="subtitle error-msg">{{ errorMsg }}</p>
                <button
                  class="btn btn-ghost1 btn-rounded btn-default btn-block waves-effect1 waves-light1 btnl1"
                  type="submit"
                  @click="login()"
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-3"></div>
        </div>
        <div class="page-title title-size-normal text-dark">
          <center>
            <button @click="openGooglePlay">
              <img
                src="/img/get_googleplay.png"
                alt="Maposcope on Google Play"
                style="padding-right: 20px"
              />
            </button>

            <button @click="openAppstore">
              <img
                src="/img/get_appstore2.png"
                alt="Maposcope on Apple Appstore"
                style="padding-left: 20px"
              />
            </button>
          </center>
        </div>

        <div class="row">
          <div class="col-md-4">.col-md-4</div>
          <div class="col-md-4">.col-md-4</div>
          <div class="col-md-4">.col-md-4</div>
        </div>
      </section>
    </article>
    <br /><br /><br /><br />

    <article>
      <section class="fw-section">
        <div style="background-color: #edf4fe">
          <div class="container fullwidthsec">
            <div class="row">
              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> sync </span> Route
                  optimization</strong
                >
                <div class="features1">
                  Best-in-class route optimization algorithms will plan the
                  shortest routes for all your drivers.
                </div>
              </div>
              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> check </span> Proof of
                  delivery</strong
                >
                <div class="features1">
                  The driver can add a photo of the delivery or the recipient's
                  signature in the app.
                </div>
              </div>

              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> check </span> Custom stop
                  details</strong
                >
                <div class="features1">
                  Add additional information about the shipment, address, and
                  delivery time, and even its location in the vehicle.
                </div>
              </div>

              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> check </span> Import delivery
                  data</strong
                >
                <div class="features1">
                  Upload a spreadsheet - add Excel or CSV files with stops
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> sync </span> Dispatch routes to
                  the drivers</strong
                >
                <div class="features1">
                  Add all delivery stops and details in the web application,
                  press the “Optimize route” button, and click “Send to
                  drivers.”
                </div>
              </div>
              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> check </span> Live route and
                  delivery tracking</strong
                >
                <div class="features1">
                  Monitor delivery progress and driver position in web app
                </div>
              </div>

              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> check </span> Dispatcher web
                  app</strong
                >
                <div class="features1">
                  Manage drivers and delivery in web app
                </div>
              </div>

              <div class="col-md-3">
                <strong
                  ><span class="material-icons"> check </span> Android and IOS
                  mobile apps</strong
                >
                <div class="features1">
                  Drivers receive their route on their phone, and route and
                  delivery data is synchronized with the cloud and visible in
                  the dispatcher's web application.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>

    <br /><br /><br /><br />
    <article>
      <section class="fw-section">
        <div class="container fullwidthsec">
          <div style="color: #404968; font-size: 40px">
            <center>How does it work?</center>
          </div>
        </div>
      </section>
    </article>
    <br /><br />

    <article>
      <section class="fw-section">
        <div style="background-color: #fff5e6; padding: 40px 0 40px 0">
          <div class="container fullwidthsec">
            <div class="row">
              <div class="col">
                <!-- <div style="font-size: 38px; color: #030d26; font-weight: 500">
                  How does it work?
                </div> -->
                <div style="font-size: 30px; color: #1972f5; font-weight: 500">
                  Dispatcher
                </div>

                <div class="list3">
                  1. Add drivers - login to dashboard and add driver emails.
                  Each driver will receive email from Maposcope with unique
                  password for him.
                </div>
                <div class="list3">
                  2. Add new route - add drivers, that will be work for this
                  deliveries.
                </div>
                <div class="list3">
                  3. Add stops - enter delivery addresses or import stops from
                  Excel or CSV
                </div>
                <div class="list3">
                  4. Add stop details - enter additional info for deliveries,
                  like package size, delivery time window, etc.
                </div>
                <div class="list3">
                  5. Press route optimize button - route will be optimized and
                  splited for all drivers added earlier
                </div>
                <div class="list3">
                  6. Press send do drivers button - all rotues will be send to
                  your drivers
                </div>
                <div class="list3">7. Monitor route progress on web app</div>
              </div>
              <div class="col">
                <img src="/img/dispatcher.png" alt="delivery dispatcher" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>

    <br />

    <article>
      <section class="fw-section">
        <div style="background-color: #fff5e6; padding: 40px 0 40px 0">
          <div class="container fullwidthsec">
            <div class="row">
              <div class="col">
                <img src="/img/driver.png" alt="delivery driver" />
              </div>
              <div class="col">
                <!-- <div style="font-size: 38px; color: #030d26; font-weight: 500">
                  How does it work?
                </div> -->
                <div style="font-size: 30px; color: #1972f5; font-weight: 500">
                  Driver
                </div>

                <div class="list3">
                  1. Driver has to check email for email from your, just created
                  Maposcope team
                </div>
                <div class="list3">
                  2. Driver have to install Maposcope Android or IPhone app and
                  login with his email and received passport.
                </div>
                <div class="list3">
                  3. Wait on notyfication from dispatcher in the app with new
                  route
                </div>
                <div class="list3">4. Press start route button in the app</div>
                <div class="list3">
                  5. Press Start and go with driver favorite navigation to first
                  delivery stop
                </div>
                <div class="list3">
                  6. At delivery stop, hand over the package, and press
                  delivered button (each stop update will be send to dispatcher
                  web app)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>

    <Footer />

    <vue-cookies-consent
      backgroundButton="#1972f5"
      borderRadius="5"
      backgroundButtonHover="#3A4F52"
      offsetY="5"
      style="z-index: 1000"
    >
      <template #description>
        <p>
          We use cookies to ensure you get the best experience on our website
          <router-link to="privacy-policy"
            ><span style="color: #0a64eb">Read more</span></router-link
          >
        </p>
      </template>
      <template #button>Accept cookies</template>
    </vue-cookies-consent>
  </v-container>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import VueCookiesConsent from "@norvikit/vue-cookies-consent";
export default {
  components: {
    Header,
    Footer,
    VueCookiesConsent,
  },
  data() {
    return {
      email: "",
      password: "",
      errorMsg: "",
    };
  },
  computed: {},
  methods: {
    login() {
      this.$store
        .dispatch("auth/login", { email: this.email, password: this.password })
        .then(
          (data) => {
            if (data.success == 1) {
              this.errorMsg = "";
              this.$router.push({
                name: "Routes",
              });
            }
          },
          (data) => {
            this.errorMsg = data["message"];
          }
        );
    },
    openGooglePlay() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.mapamai.maps.batchgeocode",
        "_blank"
      );
    },
    openAppstore() {
      window.open(
        "https://apps.apple.com/pl/app/maposcope-fast-route-planner/id1502155614",
        "_blank"
      );
    },
  },
};
</script>


<style scoped>
.error-msg {
  color: red;
  font-weight: bold;
}

.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}

ul li::before {
  content: "";
}

ul li {
  content: "";
}

.simplelist {
  margin-bottom: 10px;
}

.fullwidthsec {
  max-width: 1200px;
}
@media only screen and (max-width: 600px) {
  .fullwidthsec {
    max-width: 350px;
  }
}
</style>